export default __webpack_public_path__ + "d41005032b51d0cbe1c110f6dfd8e609.png";